export const PRIORITY_LABEL = {
  faible: "Faible",
  normale: "Normale",
  urgente: "Urgente",
  critique: "Critique",
};

export const STATUS_LABEL = {
  nouveau: "Nouveau",
  en_cours: "En cours",
  en_attente: "En attente",
  resolu: "Résolu",
  ferme: "Fermé",
};

export const STATUS_ORDER = ["nouveau", "en_cours", "en_attente", "resolu", "ferme"];

export const CATEGORY_LABEL = {
  reseau: "Réseau",
  microsoft365: "Microsoft 365",
  imprimante: "Imprimante",
  sauvegarde: "Sauvegarde",
  telephonie: "Téléphonie",
  materiel: "Matériel",
  logiciel: "Logiciel",
  autre: "Autre",
};

export const CATEGORIES = Object.keys(CATEGORY_LABEL);
export const PRIORITIES = ["faible", "normale", "urgente", "critique"];
export const STATUSES = STATUS_ORDER;

export function relTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "à l'instant";
  if (diff < 3600) return `il y a ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `il y a ${Math.floor(diff / 3600)} h`;
  if (diff < 30 * 86400) return `il y a ${Math.floor(diff / 86400)} j`;
  return d.toLocaleDateString("fr-FR");
}

// Absolute date+time in French locale: "02/09/2026 10:34"
// Use whenever context matters (comments, history, escalations) so the reader knows
// the exact moment, not just "il y a 20h".
export function absTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleString("fr-FR", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

export function slaCountdown(deadlineIso) {
  if (!deadlineIso) return { text: "—", breached: false, urgent: false };
  const d = new Date(deadlineIso).getTime();
  const diff = d - Date.now();
  const abs = Math.abs(diff);
  const h = Math.floor(abs / 3600000);
  const m = Math.floor((abs % 3600000) / 60000);
  const text = `${h}h ${m.toString().padStart(2, "0")}m`;
  return {
    text: diff < 0 ? `-${text}` : text,
    breached: diff < 0,
    urgent: diff > 0 && diff < 30 * 60 * 1000,
  };
}
